export { default } from './YesterdayPill';
